class AccountController extends AbstractController
	@register()
	@inject '$location',
		'$window'
		'$uibModal'
		'$sce'
		'API_ENDPOINT'
		'AuthenticationService'
		'ConfigurationService'
		'EntityAttributeService'
		'EPAY_MERCHANT_NUMBER'
		'UserInformation'
		'AccountLicenseService'
		'MakeSecretRepository'
		'AdyenSubscriptionRepository'
		'MasterUserRepository'
		'PaymentSubscriptionRepository'
		'ToastService'
		'UserService'
		'CompaniesCount'
		'currentLicense'
		'licenseBundles'
		'CredentialsManager'
		'Infrasec'
		'InfrasecRepository'
		'registersCount'
		'termsAndConditionsUrl'
		'priceRegions'
		'languages'
		'translate'
		'AuthenticationRepository'

	initialize: ->
		@isLoginQrCodeGenerationEnabled = @ConfigurationService.isEnabled 'Shared.Setting.LoginQRCodeGeneration.Enabled'

		@distributor = null
		@isUser = @UserInformation.getSubUser()?
		@showQrCodeGeneration = @isLoginQrCodeGenerationEnabled && !@isUser
		@showLicenseInfo = @ConfigurationService.isEnabled 'Backoffice.AccountManagement.EnableLicense'
		@isEpayEnabled = @ConfigurationService.isEnabled 'Backoffice.Setting.SubscriptionPayment.Epay.Enabled'
		@useEpay = false
		@termsUrl = @termsAndConditionsUrl
		@settings = _.pick(
			@UserInformation.getMasterUser()
			'id'
			'email'
			'zipcode'
			'street_name'
			'city'
			'phone_number'
			'contact_person'
			'company_name'
			'accepted_terms'
			'price_region_id'
			'cvr'
			'language_id'
		)
		@company =
			cvr: @settings.cvr
			infrasec: @Infrasec.data.active

		@password = {}
		@multipleCompanies = @CompaniesCount > 1
		@showInfrasec = @Infrasec.data.enabled

		@licenseChangeEnabled = false

		# Current license
		if @currentLicense
			@currentLicense.deactivated = @currentLicense.auto_renew != "1"
			@currentLicense.price = parseInt(@currentLicense.price, 10)

			if @currentLicense.num_of_registers?
				@licenseChangeEnabled = parseInt(@currentLicense.payment_period_in_days) == 30
				@currentLicense.price_per_register = @currentLicense.price / @currentLicense.num_of_registers
			else
				@showLicenseInfo = false
				@currentLicense.price_per_register = 0
				@currentLicense.num_of_registers = @registersCount

			@currentLicense.min_registers = 1

			if @currentLicense.price == null
				newBundle = _.findWhere(
					@licenseBundles,
					(item) ->
						return item.name == "WM_BASE_DK" || item.name == "WM_BASE_NO" || item.name == "WM_BASE_SE"
				)
				priceForCountry = _.findWhere(newBundle[0].licensePlans[0].licensePlanPeriods[0].licensePlanPrices, {currency: @currentLicense.currency})
				@currentLicense.price = priceForCountry.register_price_per_period * @registersCount

			@changeRequest = {
				new_number_of_registers: @currentLicense.num_of_registers
				new_price: @currentLicense.price
			}

		@setCardInfo()
		@setDistributorInfo()

		@tabs = [
			{
				title: 'general.user.data'
				selector: '#tab-user-data'
			}
			{
				title: 'general.company'
				selector: '#tab-company'
			}
			{
				title: 'general.license'
				selector: '#tab-license'
				disabled: !@showLicenseInfo
			}
			{
				title: 'general.credit.card'
				selector: '#tab-credit-card'
			}
			{
				title: 'general.distributor'
				selector: '#tab-distributor'
				disabled: !@distributor?
			}
		]

	setDistributorInfo: ->
		if @UserInformation.getMasterUser().distributor
			@distributor = @UserInformation.getMasterUser().distributor

			if @distributor
				@distributor.attributesService = @EntityAttributeService.getNewInstance()
				@distributor.attributesService.setEntity @UserInformation.getMasterUser().distributor,
					'BACKEND_DISTRIBUTOR_ATTRIBUTE_TYPE',
					{
						email: null
						phone_number: null,
						logo_url: null
					}

	saveCompany: ->
		if @multipleCompanies
			@saveInfrasec(@company.infrasec)

			return

		@MasterUserRepository
			.patch @settings.id, {cvr: @company.cvr}
			.then =>
				@saveInfrasec(@company.infrasec)
					.then =>
						@ToastService.add(
							@company.cvr,
							@translate('general.company'),
							@translate('alert.saved'),
							'success'
						)
						@$window.location.reload()
			.catch (response) =>
				@handleErrors response.data
				@ToastService.showErrors response.data, @translate('general.company')

	saveInfrasec: (status) ->
		@InfrasecRepository
			.setStatus status
			.then =>
				@forms.company.$setPristine()
			.catch (response) =>
				@ToastService.showErrors response.data, @translate('general.company')

	subtractNewRegisters: ->
		if parseInt(@changeRequest.new_number_of_registers) == 1
			@ToastService.add "You cannot get below " + @currentLicense.min_registers + " registers", 'Register', 'error', 'error', 3000
		else
			if (@changeRequest.new_number_of_registers > @registersCount)
				@changeRequest.new_number_of_registers = parseInt(@changeRequest.new_number_of_registers) - 1
				@calculateNewPrice()
			else
				@ToastService.add "You currently have " +  @registersCount + " registers. Delete some before removing them from the license", 'Register', 'error', 'error', 3000

	addNewRegister: ->
		@changeRequest.new_number_of_registers = parseInt(@changeRequest.new_number_of_registers) + 1
		@calculateNewPrice()

	calculateNewPrice: ->
		@changeRequest.new_price = parseInt(@changeRequest.new_number_of_registers) * parseInt(@currentLicense.price_per_register)

	calculatePriceWithoutVat: (vatrate, price) ->
		return parseInt(price, 10) / (1 + parseFloat(vatrate))

	saveMasterUser: ->
		@MasterUserRepository
			.patch @settings.id, @settings
			.then =>
				@ToastService.add(
					@settings.email,
					@translate('general.account'),
					@translate('alert.updated'),
					'success'
				)
				@forms.user.$setPristine()
			.catch (response) =>
				@handleErrors response.data
				@ToastService.showErrors response.data, @translate('general.account')

	saveAcceptedTerms: ->
		accepted = {'accepted_terms': @settings.accepted_terms}

		@MasterUserRepository
			.patch @settings.id, accepted
			.then =>
				@ToastService.add(
					@settings.email,
					@translate('general.account'),
					@translate('alert.updated'),
					'success'
				)
			.catch (response) =>
				@handleErrors response.data
				@ToastService.showErrors response.data, @translate('general.account')

	savePassword: ->
		@UserService
			.updatePassword @password
			.then =>
				@ToastService.add(
					@settings.email,
					@translate('general.password'),
					@translate('alert.updated'),
					'success'
				)

				@password = {}
				@forms.password.$setPristine()
				@forms.password.$setUntouched()
			.catch (response) =>
				@ToastService.showErrors(response.data, @translate('general.password'))

	updateCard: ->
		if !@useEpay
			@updateCardUsingAdyen()

			return

		ordertext = @translate('wbo.cardinfo.renewal') + ' ' + @settings.email
		fields = {
			"accepturl": do @$location.protocol + '://' + do @$location.host + do @$location.path
			"amount":"0"
			"callbackurl": @API_ENDPOINT + "/confirm_payment_change/" + @settings.id + "?access_token=" + @CredentialsManager.getResourceToken()
			"currency":"208"
			"instantcallback":"1"
			"language":"2"
			"merchantnumber":@EPAY_MERCHANT_NUMBER
			"ordertext": ordertext
			"subscription":"1"
			"windowstate":"1"
		}
		hashContent = ''

		for k, v of fields
			hashContent += v

		@MakeSecretRepository
			.post '', {'content': hashContent}
			.then (response) ->
				if PaymentWindow?
					fields.hash = response.data.hash
					paymentWindow = new PaymentWindow(fields)
					paymentWindow.open()

	updateCardUsingAdyen: ->
		@AdyenSubscriptionRepository
			.subscribe()
			.then (response) =>
				@$window.location.href = response.data.subscription_confirmation_url

	removeCard: (id) ->
		for card in @cards
			@PaymentSubscriptionRepository
				.delete(card.id)
				.then =>
					delete @cards

	setCardInfo: ->
		@PaymentSubscriptionRepository
			.list()
			.then (response) =>
				@cards = response.data

	toggleLicenseDeactivation: ->
		@AccountLicenseService
			.toggleRenewal(@currentLicense)
			.then =>
				@currentLicense.deactivated = !@currentLicense.deactivated

				if @currentLicense.deactivated
					message = @translate('wbo.license.deactivated')
				else
					message = @translate('wbo.license.reactivated')

				@ToastService.add(
					message,
					@translate('general.license'),
					@translate('alert.saved'),
					'success'
				)
			.catch (response) =>
				console.error("Could not toggle license", response.data)
				@ToastService.showErrors response.data, @translate('general.license')

	changeLicense: ->
		model =
			num_of_registers: @changeRequest.new_number_of_registers

		if @currentLicense.id
			@AccountLicenseService
				.changeLicense(@currentLicense.id, model)
				.then =>
					@setNewLicense()
					@ToastService.add(
						@translate('wbo.license.change'),
						@translate('general.license'),
						@translate('alert.saved'),
						'success'
					)
				.catch (response) =>
					@ToastService.showErrors response, @translate('general.license')
		else
			@ToastService.add(
				@translate('wbo.license.not.found'),
				@translate('general.license'),
				@translate('general.error'),
				'error'
			)

	setNewLicense: ->
		@currentLicense.num_of_registers = @changeRequest.new_number_of_registers
		@currentLicense.price = @changeRequest.new_price

	resolveQrCodeUrl: ->
		return @AuthenticationRepository
			.generateQrCode()
			.then (qrCode) => @$sce.trustAsResourceUrl(URL.createObjectURL(qrCode))

	disposeQrCodeUrl: (url) ->
		URL.revokeObjectURL(url.rawUrl)

	openDeleteAccountModal: ->
		@$uibModal
			.open
				templateUrl: '@app/account/modals/account.account-delete.modal.view.html'
				bindToController: true
				size: 'md'
				controllerAs: 'deletionModal'
				controller: 'AccountDeleteModalController'
			.result
			.then =>
				@MasterUserRepository
					.delete(@UserInformation.getMasterUser().id)
					.then =>
						@AuthenticationService.logout()
